// Thirdparty
import React, {useState, useEffect, useRef} from "react";
import ReactDom from 'react-dom';
// Styles
import '../styles/Modal.css';
import '../styles/UpdateMobileModal.css';
// Services
const Routes = require("./../services/routes.js");

function showErrorMessage(message){
  //document.getElementById("um-errorMessage").style.display = "inline";
  //document.getElementById("um-errorMessage").innerText = "* " + message;
}

// Function to update mobile. Fetch API to server.
async function fetchUpdateMobile(item){
  try{
    const url = Routes.getAuthUserURL() + "/mobile";
    const origin = window.location.origin;
    console.debug(`Sending message to ${url} with origin ${origin}`);

    const response = await fetch(
      url,
      {
        method: "POST",
        headers: {"content-type": "application/json"},
        credentials: "include",
        body: JSON.stringify(item),
      }
    );
    const result = await response.json();
    
    // Failure
    if(!response.ok){
      console.error(`Failed to fetch mobile: ${response.statusText} Status:${response.status}`);
      
      // If the response was unauthorized
      if(response.status===401){
        localStorage.removeItem('verified'); // Remove verified
        window.location = `/`; // redirect the page to the home page.
      }
      //showErrorMessage(result.message);
      return;
    }
    // Redirect
    else if (result.redirect){
      window.location = result.url;
      localStorage.removeItem('verified');
      return;
    }
    else if(typeof result.verified !== 'undefined'){
      localStorage.verified = result.verified;
    }
    
    //! \todo Success
  }
  catch(err){
    console.error("Failed to fetch mobile: ", err);
  }
}

function UpdateMobileModal({open, onClose, children}){
  // Modal states
  const [mobile, setMobile] = useState("");

  // Ref for the modal element
  const modalRef = useRef(null);

  useEffect(()=>{
    // Function to handle clicks outside the modal
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose(); // Close the modal if click is outside
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const onUpdate = (event) => {
    event.preventDefault();

    // fetch post to backend server
    // todo this modal will close before the server responses, why? Potentially due to submit.
    // The modal should stay open and display and error message on error.
    fetchUpdateMobile({mobile});
  };

  if(!open){
    return null;
  }

  return ReactDom.createPortal(
    <>
        <div className="modal-overlay"/>
        <div className="modal um-modal" ref={modalRef}>
          <button className="um-close" onClick={onClose}>X</button>

          <div>
            <h2 className="um-header">Update Mobile</h2>
          </div>

          <form id="login" className="um-input-group" onSubmit={onUpdate}>
            <label for="mobile">Mobile</label>
            <input type="mobile" className="um-input-field" placeholder="Type your mobile"  value={mobile} onChange={(e) => setMobile(e.target.value)} required />
            <input type="submit" className="um-submit-btn" value='UPDATE'/>
          </form>

          <div id="um-errorDiv">
            <p id="um-errorMessage">
              * Error message pending.
            </p>
          </div>

          {children}
        </div>
      </>,
      document.getElementById('portal')
  )
}

export default UpdateMobileModal;
